import React from 'react';
import AddLawyer from './AddLawyer';
import OtherLawyers from './OtherLawyers';
import FAQ from './FAQ';

function DodajPrawnika() {
  return (
    <div>
        <AddLawyer />
        <OtherLawyers />
        <FAQ />
    </div>
  )
}

export default DodajPrawnika